// src/index.js
import '../setNodeOptions';
import './bundle.js';
import './widget.js';

console.log("SushiSwapBundle:", window.SushiSwapBundle);
